import { useMemo } from "react";
import { CartItemModel } from "../models";
import { useOrderOption, useStore } from "../hooks";
import { useCart } from "../hooks";

// const utmTag = import.meta.env.VITE_APP_UTM_TAG;

export const useCartPrice = (cartItem?: CartItemModel): number => {
  const { storeProducts } = useStore();
  const { orderOption } = useOrderOption();
  const { cartItems } = useCart();

  // ✅ Helper to compute price for a single cart item (no hooks used inside)
  const calculateItemPrice = (item: CartItemModel): number => {
    return Number(item.product_price) + Number(item.product_convenience);

    // const product = storeProducts.find(p => p.id === item.product_id);
    // if (!product) return 0;

    // const inflation = Array.isArray(product.convenience)
    //   ? 0
    //   : Number(product.convenience?.[String(orderOption.type_id)] || 0);

    // const adInflation = Array.isArray(product.convenience)
    //   ? 0
    //   : utm == utmTag ? Number(product.convenience?.["adsp"] || 0) : 0;

    // const basePrice = Number(product.product_price) + inflation + adInflation;

    // const modifierTotal = item.modifier_group?.reduce((sum, group) =>
    //   sum + group.modifiers.reduce((sub, mod) => {
    //     const storeModifier = product.modifier_group
    //       ?.flatMap(pg => pg.modifier)
    //       .find(sm => sm.m_id === mod.m_id);

    //     const modInflation = Array.isArray(storeModifier?.convenience)
    //       ? 0
    //       : Number(storeModifier?.convenience?.[String(orderOption.type_id)] || 0);

    //     const adInflation = Array.isArray(storeModifier?.convenience)
    //       ? 0
    //       : utm == utmTag ? Number(storeModifier?.convenience?.["adsp"] || 0) : 0;

    //     return sub + (Number(mod.m_price) + modInflation + adInflation);
    //   }, 0)
    // , 0) || 0;

    // return (basePrice + modifierTotal) * item.product_qty;
  };

  // ✅ For single item (safe)
  const itemPrice = useMemo(() => {
    return cartItem ? calculateItemPrice(cartItem) : 0;
  }, [cartItem, storeProducts, orderOption.type_id]);

  // ✅ For total (no hooks inside loop)
  const cartTotal = useMemo(() => {
    return cartItems?.reduce(
      (sum, item) =>
        sum + (calculateItemPrice(item) - Number(item.product_discount)),
      0,
    );
  }, [cartItems, storeProducts, orderOption.type_id]);

  return cartItem ? itemPrice : cartTotal;
};
